module.exports = __webpack_public_path__ + "static/fp1-3760513559101a7a113ae8003f5e3bc5.jpg";